import React from "react";

import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import "./style.scss";
import { TextButton } from "@shape-ds/components";

interface EmptyMessageProps {
  message: React.ReactNode;
  title?: string;
  className?: string;
  showIcon?: boolean;
  textBtn?: string;
  onClickBtn?: () => void;
}
const EmptyMessage: React.FC<EmptyMessageProps> = ({
  message,
  title,
  className,
  showIcon = true,
  textBtn,
  onClickBtn,
}) => {
  return (
    <div className={`asset-events-empty-message empty-message ${className}`}>
      {showIcon && <CancelOutlinedIcon />}
      {title && <span>{title}</span>}
      <div className="empty-message-content">
        <p className="empty-message-text">{message}</p>
        {textBtn && (
          <TextButton className="empty-message-btn" onClick={onClickBtn}>
            {textBtn}
          </TextButton>
        )}
      </div>
    </div>
  );
};

export default EmptyMessage;
